import React from "react";
import { Snowflake, Instagram, Globe, Mail, Phone } from "lucide-react";
import { guide } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0f261e] text-[#faf5ec] pt-16 pb-8 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-3 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Snowflake className="w-5 h-5 text-[#e9c987]" strokeWidth={1.5} />
              <div className="flex flex-col leading-none">
                <span className="font-display text-xl">Beyond the Path</span>
                <span className="font-script text-[#e9c987] text-base -mt-1">travel</span>
              </div>
            </div>
            <p className="text-[#faf5ec]/70 text-sm font-light leading-relaxed max-w-xs">
              Curated group travel for women who want their getaways to feel personal, festive and unforgettable.
            </p>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#e9c987] mb-4">The Trip</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#overview" className="text-[#faf5ec]/80 hover:text-[#e9c987] transition-colors">Overview</a></li>
              <li><a href="#cities" className="text-[#faf5ec]/80 hover:text-[#e9c987] transition-colors">Cities</a></li>
              <li><a href="#itinerary" className="text-[#faf5ec]/80 hover:text-[#e9c987] transition-colors">Itinerary</a></li>
              <li><a href="#pricing" className="text-[#faf5ec]/80 hover:text-[#e9c987] transition-colors">Pricing</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#e9c987] mb-4">Get in Touch</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2 text-[#faf5ec]/80">
                <Mail className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
                <a href={`mailto:${guide.email}`} className="hover:text-[#e9c987] transition-colors">{guide.email}</a>
              </li>
              <li className="flex items-center gap-2 text-[#faf5ec]/80">
                <Phone className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
                <a href={`tel:${guide.phone}`} className="hover:text-[#e9c987] transition-colors">{guide.phone}</a>
              </li>
              <li className="flex items-center gap-2 text-[#faf5ec]/80">
                <Instagram className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
                <a href="https://instagram.com/beyondthepath_" target="_blank" rel="noopener noreferrer" className="hover:text-[#e9c987] transition-colors">@beyondthepath_</a>
              </li>
              <li className="flex items-center gap-2 text-[#faf5ec]/80">
                <Globe className="w-4 h-4 text-[#e9c987]" strokeWidth={1.5} />
                <a href="https://beyondthepathtravel.com/christmas" target="_blank" rel="noopener noreferrer" className="hover:text-[#e9c987] transition-colors">beyondthepathtravel.com/christmas</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-[#faf5ec]/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#faf5ec]/50">
          <p>© {new Date().getFullYear()} Beyond the Path Travel. All journeys reserved.</p>
          <p className="font-script text-base text-[#e9c987]/80">wandering, together.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
